import Highcharts from 'highcharts';
import { getEmploymentData } from "./chart-salaries.js";

/**
 * @param {string} id
 */
export default function chartStructure(id) {
    if (!document.getElementById(id)) return;

    const cityData = getEmploymentData()
        .filter(item => item.civilians !== null)
        .sort((a, b) => b.civilianRatio - a.civilianRatio);

    const categories = cityData.map(item => item.city);
    const guardsData = cityData.map(item => item.filledGuards);
    const civilianData = cityData.map(item => item.civilians);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Employment structure: Uniformed vs Civilians' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            min: 0,
            title: { text: 'Percentage share' },
            reversedStacks: false
        },
        tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
            shared: true
        },
        plotOptions: {
            series: {
                stacking: 'percent',
                dataLabels: { enabled: true, format: '{point.percentage:.1f}%' }
            }
        },
        legend: { reversed: true },
        credits: { enabled: false },
        series: [{
            name: 'Civilian employees',
            data: civilianData,
            color: '#f1c40f'
        }, {
            name: 'City guards',
            data: guardsData,
            color: '#2c3e50'
        }]
    });
}
